module.exports = __webpack_public_path__ + "img/swiper4_d.c455979a.png";